// extracted by mini-css-extract-plugin
export default {"change-pass-wrapper":"ChangePassword_change-pass-wrapper__faW4e","input-wrapper":"ChangePassword_input-wrapper__AlGCT"};